import { MainSidebarProvider } from "@/components/Sidebar/MainSidebarLayout/MainSidebarLayoutStyling";
import { Outlet } from "react-router-dom";
import MainSidebarInset from "@/components/Sidebar/MainSidebarLayout/MainSidebarInset";


export default function MainSidebarLayout() {
    return (
      <MainSidebarProvider defaultOpen={false}>
          <MainSidebarInset />
          
          <Outlet />
      </MainSidebarProvider>
    );
}